// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a5076e9a","806":"da62a335"}[chunkId] + ".chunk.js";
};